import { ClaimTypesEnum } from '../../utils';
import React, { CSSProperties } from 'react';
import { IconTitle } from 'components/iconTitle';
import LogoOutPatient from 'assets/images/claims/outpatient.svg';
import LogoHospitalisation from 'assets/images/claims/hospitalisation.svg';
import LogoMaternity from 'assets/images/claims/maternity.svg';
import LogoDental from 'assets/images/claims/dental.svg';

export const ClaimTypeIconLabel = (description: string, claimTypeCode: ClaimTypesEnum) => {
  const iconStyle: CSSProperties = {
    width: 16,
    height: 16,
  };
  switch (claimTypeCode) {
    case ClaimTypesEnum.OP:
      return <IconTitle iconStyle={iconStyle} level={0} title={description || ''} icon={LogoOutPatient} />;
    case ClaimTypesEnum.DEN:
      return <IconTitle iconStyle={iconStyle} level={0} title={description || ''} icon={LogoDental} />;
    case ClaimTypesEnum.MAT:
      return <IconTitle iconStyle={iconStyle} level={0} title={description || ''} icon={LogoMaternity} />;
    case ClaimTypesEnum.HOSP:
      return <IconTitle iconStyle={iconStyle} level={0} title={description || ''} icon={LogoHospitalisation} />;
    default:
      return <IconTitle level={0} title={description || ''} />;
  }
};
